/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  padding: calc(6rem/14) calc(8rem/14);
  margin-right: calc(16rem/14);
  color: #FFF;
  color: var(--davinci-color-text-on-secondary, #FFF);
  background-color: #323C43;
  background-color: var(--davinci-color-secondary, #323C43);
}
:host .wrapper {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: stretch;
  -webkit-box-align: start;
          align-items: flex-start;
}
:host .wrapper .slotwrapper {
  font-size: calc(12rem/14);
  line-height: calc(16rem/14);
  -webkit-box-flex: 1;
          flex: 1 1 auto;
}
:host .wrapper > .close {
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  width: calc(16rem/14);
  height: calc(16rem/14);
  margin-top: calc(1rem/14);
  margin-left: calc(16rem/14);
  cursor: pointer;
}
:host .wrapper > .close svg {
  width: calc(16rem/14);
  height: calc(16rem/14);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary, #FFF);
}
:host .wrapper > .close:hover {
  background-color: #505F6B;
  background-color: var(--davinci-color-secondary-light, #505F6B);
}
:host .wrapper > .close:hover svg {
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFF);
}
:host .wrapper > .close:focus {
  background-color: #8999A4;
  background-color: var(--davinci-color-midgray-1, #8999A4);
  outline: none !important;
}
:host .wrapper > .close:focus svg {
  fill: #323c43;
  fill: var(--davinci-color-text-on-midgray-1, #323c43);
}`;
export { style };
//# sourceMappingURL=Tag.style.js.map